type PaginationProps = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) {
    return null;
  }

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <div className="mt-9 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-500 transition-colors hover:border-accent-500 hover:text-accent-500 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={`h-9 min-w-9 rounded-md px-2 text-sm transition-colors cursor-pointer ${
            item === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-500 hover:border-accent-500 hover:text-accent-500"
          }`}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-500 transition-colors hover:border-accent-500 hover:text-accent-500 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}